import { render, staticRenderFns } from "./SponsorProcess.vue?vue&type=template&id=646b86fc&scoped=true"
import script from "./SponsorProcess.vue?vue&type=script&lang=js"
export * from "./SponsorProcess.vue?vue&type=script&lang=js"
import style0 from "./SponsorProcess.vue?vue&type=style&index=0&id=646b86fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646b86fc",
  null
  
)

export default component.exports